module.exports = __webpack_public_path__ + "img/management-team-icon.df642300.svg";